import { getToken } from "@chakra-ui/react";

const baseStyle = ({ theme }) => ({
  field: {
    px: 6,
    width: "100%",
    outline: "solid 2px transparent",
    outlineOffset: "2px",
    position: "relative",
    appearance: "none",
    transitionProperty: "common",
    transitionDuration: "normal",
    pb: "1px",
    bg: "inherit",
    height: "36px",
    borderRadius: "24px",
    border: "1px solid",
    borderColor: "outline",
    fontSize: "14px",
    option: {
      bg: "surface",
      borderColor: "outline"
    },
    _focus: {
      borderColor: "primary",
      boxShadow: `0 0 0 1px ${getToken("colors", "primary")(theme)}`
    }
  },
  icon: {
    width: 8,
    height: "100%",
    right: 2,
    color: "currentColor",
    fontSize: "2.5rem",
    position: "absolute",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
    top: "50%",
    transform: "translateY(-50%)"
  }
});

export default {
  baseStyle
};
